import { render, staticRenderFns } from "./certificateDataProHire.vue?vue&type=template&id=0532e10b&"
import script from "./certificateDataProHire.vue?vue&type=script&lang=js&"
export * from "./certificateDataProHire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports